<template>
  <div>
    <el-dialog
      top="5vh"
      v-loading="loading"
      :title="'冻结账单，项目：'+house_name"
      :visible.sync="dialogVisible"
      width="80%"
      :before-close="handleClose">
      <div style="height: 75vh;overflow-y: auto;">
        <el-button @click="selects_s()">查询</el-button>
        <el-button @click="update(1)">冻结</el-button>
        <el-button @click="update(2)">解冻</el-button>
        <el-button @click="update(3)">全部冻结</el-button>
        <el-button @click="update(4)">全部解冻</el-button>
        <div>
            <el-descriptions :column="2" border size="mini" style="margin-top: 10px;" :labelStyle="{width: '123px'}" :contentStyle="{width:'42%'}">
              <el-descriptions-item  label="冻结状态">
                <RadioGroup v-model="select.frozen">
                    <Radio label="未冻结"></Radio>
                    <Radio label="已冻结"></Radio>
                </RadioGroup>
              </el-descriptions-item>
              <el-descriptions-item label="房产信息">
                <el-select v-model="select.house" @change="houses" size="mini" placeholder="可搜索房产" filterable remote clearable reserve-keyword :remote-method="remoteMethod" style="width: 100%;">
                    <el-option v-for="item in house" :key="item.id" :label="item.house" :value="item.house"></el-option>
                </el-select>
              </el-descriptions-item>
              <el-descriptions-item  label="计费周期">
                <el-date-picker v-model="date.startDate" type="date" size="mini" style="width: 47%;" placeholder="开始日期"></el-date-picker>
                <span style="margin-left: 1px;margin-right: 1px;">至</span>
                <el-date-picker v-model="date.endDate" type="date" size="mini" style="width: 47%;" placeholder="结束日期"></el-date-picker>
              </el-descriptions-item>
              <el-descriptions-item label="收费项目">
                <el-select v-model="select.chargeitem_id" size="mini" multiple filterable collapse-tags placeholder="收费项目" style="width: 90.5%;">
                  <el-option v-for="item in chargeitem" :key="item.id" :label="item.chargeItem_name" :value="item.id"></el-option>
                </el-select>
                <span style="cursor: pointer;margin-left: 3px;" @click="complete">全选</span>
                <span style="margin-left: 3px; cursor: pointer" @click="cancel">取消</span>
              </el-descriptions-item>
            </el-descriptions>
        </div>
        <div style="margin-top: 10px;">
          <span>选中金额：<span style="color: red;">{{money_val}}</span>元</span>
          <span style="margin-left: 15px;">总金费：<span style="color: red;">{{money}}</span>元</span>
          <span style="margin-left: 15px;color: red;" v-if="loading_dade==2">加载中...</span>
          <el-table ref="multipleTable" :data="tableData" border tooltip-effect="dark" style="width: 100%" height="60vh"  @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="customer" label="姓名" width="100"></el-table-column>
            <el-table-column prop="h_name_date" label="房产" show-overflow-tooltip></el-table-column>
            <el-table-column prop="chargeitem_name" label="收费项目" width="130"></el-table-column>
            <el-table-column prop="xsc_Price" label="单价" width="80"></el-table-column>
            <el-table-column prop="xsc_Amount" label="数量" width="80"></el-table-column>
            <el-table-column label="计费周期" width="180">
              <template slot-scope="scope">
                {{scope.row.startDate}}-{{scope.row.endDate}}
              </template>
            </el-table-column>
            <el-table-column prop="adjust_after" label="应收金额" width="80"></el-table-column>
            <el-table-column prop="PaidChargeSum" label="已缴金额" width="80"></el-table-column>
            <el-table-column prop="discount" label="减免金额" width="80"></el-table-column>
            <el-table-column prop="charge_money" label="本次应收" width="80"></el-table-column>
            <el-table-column prop="state_name" label="状态" width="80"></el-table-column>
            <el-table-column prop="IsFrozen" label="冻结状态" width="80"></el-table-column>
            <!-- <el-table-column prop="remark" label="备注" width="200"></el-table-column> -->
          </el-table>
        </div>
      </div>
      <div class="pages">
        <Page :total="total" :page-size="page" @on-change="selects" show-total />
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
      // 接受父组件的值
      props: {

      },
      watch:{

      },
      data () {
        return {
          total:0,
          page:20,
          dialogVisible:false,
          tableData: [],
          order: [],
          money_val:0,
          money:0,
          date:{
            date_s:'',
            date_e:'',
            startDate:'',
            endDate:'',
          },
          select:{
            pay:'',
            house:'',
            name:'',
            date:'',
            chargeitem_id:[],
            frozen:"未冻结"
          },
          customer:[],
          dataPay:[],
          xsc_bill_no:'',
          house:[],
          chargeitem:[],
          loading:false,
          loading_dade:1,
          pid:'',
          house_name:''
        }
      },
      mounted(){
        //加载收费大类（费项）
        this.$myhttp
          .get("admin/common/getChargeitem", {
            "Content-Type": "application/json",
          })
          .then((backdata) => {
            this.chargeitem = backdata.data.data;
          });
      },
      //事件
      methods: {
        //返回数据
        getInvo(data,house,dataPay,customer,pid){
          this.pid=pid;
          this.select = data;
          if(this.date.date_s == ''){
            this.date.date_s  = data.date;
            this.date.date_e = data.date;
          }
          this.select.frozen = "未冻结";
          this.select.pay = '';
          this.dataPay = dataPay;
          this.house = house;
          this.customer = customer;
          this.dialogVisible = true;
          this.select.chargeitem_id = [];
          this.selects_s();
          this.housePid();
        },
        del(){
          this.select.pay = '';
        },
        //全选
        complete() {
          let data = this.chargeitem;
          let id = data
            .map((ret) => {
              return ret.id;
            })
            .join(",");
          let idarray = "[" + id + "]";
          this.select.chargeitem_id = JSON.parse(idarray);
        },
        //取消
        cancel() {
          this.select.chargeitem_id = [];
        },
        // 冻结
        update(e){
          this.$confirm('确定操作吗, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.loading = true;
            let date = {'order':this.order,'type':e,'select':this.select,'date':this.date,'pid':this.pid};
            this.$myhttp.post('admin/OrderListFrozen/update',date,{
              'Content-Type': 'application/x-www-form-urlencoded'
              }).then(backdata=>{ // 异步执行成功后
                this.loading = false;
                if(backdata.data.code == 201){
                  this.$Message.error(backdata.data.message);
                }else{
                  this.$Message.success(backdata.data.message);
                  this.selects(1);
                }
            },err=>{
              this.loading = false;
              this.$Message.error('请求异常!');
            });
          })
        },
        selects_s(){
          this.money = "加载中";
          this.total = 1;
          this.selects(1);
          let data = {'select':this.select,'date':this.date,'xsc_bill_no':this.xsc_bill_no,'type':1,'page':1,'pid':this.pid}
          this.$myhttp.post('admin/OrderListFrozen/money',data,{
            'Content-Type': 'application/x-www-form-urlencoded'
            }).then(backdata=>{ // 异步执行成功后
              this.money = backdata.data.money;
              this.total = backdata.data.count;
          },err=>{
            this.$Message.error('请求异常!');
          });
        },
        // 查询
        selects(e){
          this.loading_dade = 2;
          let data = {'select':this.select,'date':this.date,'xsc_bill_no':this.xsc_bill_no,'type':1,'page':e,'pid':this.pid}
          this.$myhttp.post('admin/OrderListFrozen/paid',data,{
            'Content-Type': 'application/x-www-form-urlencoded'
            }).then(backdata=>{ // 异步执行成功后
              this.loading_dade = 1;
              this.tableData = backdata.data.data;
          },err=>{
            this.loading_dade = 1;
            this.$Message.error('请求异常!');
          });
        },
        handleClose(done) {
          done();
        },
        handleSelectionChange(val) {
          this.order = val;
          let money = 0;
          this.order.map(req=>{
              money = Number(money) + Number(req.charge_money);
          })
          this.money_val = money.toFixed(2);
        },
        //远程搜索
        remoteMethod(query){
          if (query !== '') {
            this.$myhttp.get('admin/common/house_name1?house_name='+query+'&pid='+this.pid,{
              'Content-Type': 'application/json'
              }).then(backdata=>{ // 异步执行成功后
                this.house = backdata.data.data;
            });
          }
        },
        //更换项目id
        houses(e){
          if(e){
            this.house.map(req=>{
              if(req.house == e){
                this.pid = req.erp_pindex_id;
              }
            })
          }
          this.housePid();
        },
        //查询当前项目
        housePid(){
          this.$myhttp.get('admin/common/house_pid?pid='+this.pid+"&house="+this.select.house,{
            'Content-Type': 'application/json'
            }).then(backdata=>{ // 异步执行成功后
              if(backdata.data.code == 200){
                this.house_name = backdata.data.data.name;
                this.pid = backdata.data.data.id;
              }
          });
        }
    },
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Admin/Order/order/frozen.vue